import React from 'react'

export default function HeroMessageEn() {
  return (
    <p className="px-8 text-center text-3xl font-bold !leading-[2.5] text-white md:text-left md:text-5xl md:!leading-[2] lg:p-0">
      First Information & Interactive Platform for
      <br />
      <span className="text-primary-600 text-5xl font-black md:text-6xl"> FUTURE </span>
      <span className="text-secondary-600 text-5xl font-black md:text-6xl"> MINERALS </span>
      <br />
      In the Arab Region
    </p>
  )
}
